import styled from "styled-components";
import Modal from "../../components/Modal";

const WebinarSuccessModal = ({ isOpen, webinar, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    label="¡Inscripción exitosa!"
    acceptButtonText="Cerrar"
    cancelButton={false}
    onAccept={onClose}
    width="420px"
  >
    <Content>
      <Icon>🎉</Icon>
      <Message>
        Te has inscrito correctamente en <strong>{webinar?.titulo}</strong>.
      </Message>
      <Detail>Te enviaremos un recordatorio al correo registrado antes del evento.</Detail>
    </Content>
  </Modal>
);

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 8px 8px 0;
`;

const Icon = styled.span`
  font-size: 48px;
`;

const Message = styled.p`
  margin: 0;
  color: #111827;
  font-size: 15px;
  line-height: 1.6;

  strong {
    font-weight: 700;
  }
`;

const Detail = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.5;
`;

export default WebinarSuccessModal;
